import React from 'react';

import { FilterSpam, type FilterSpamComponentProps } from '@pkg/components/Sections/Profile/Filters';
import { NftFiltersKey, useNftFilter } from '@pkg/providers';

export type GroupFilterSpamProps = Pick<FilterSpamComponentProps, 'index'>;

const FILTER_KEY = NftFiltersKey.Spam;

export function GroupFilterSpam({ index }: GroupFilterSpamProps) {
    // TODO: Should this component even render if `!enableSpamFilter`?
    const [filters, setFilters] = useNftFilter();

    const spamFromFilters = filters.getLastValue(FILTER_KEY);
    const currentSpam = spamFromFilters === 'true' || spamFromFilters === true;

    const handleUpdateSpam: FilterSpamComponentProps['onChange'] = (value) => {
        if (value) {
            filters.set(FILTER_KEY, [true]);
        } else {
            filters.delete(FILTER_KEY);
        }

        setFilters(filters);
    };

    return <FilterSpam index={index} state={currentSpam} onChange={handleUpdateSpam} />;
}
